import EmailSummary from './EmailSummary';

export default EmailSummary;
